import { render, staticRenderFns } from "./editWebDetail.vue?vue&type=template&id=24e480f3&scoped=true&"
import script from "./editWebDetail.vue?vue&type=script&lang=js&"
export * from "./editWebDetail.vue?vue&type=script&lang=js&"
import style0 from "./editWebDetail.vue?vue&type=style&index=0&id=24e480f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e480f3",
  null
  
)

export default component.exports